import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { AppState } from '@app/store/states/app.state';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { LANGUAGE_KEY } from '@shared/utils/constants';

@Component({
  selector: 'app-language-menu',
  templateUrl: './language-menu.component.html',
  imports: [CommonModule, MatButton, MatMenu, MatMenuItem, MatMenuTrigger, MatIcon, TranslocoDirective]
})
export class LanguageMenuComponent {
  public readonly appState = inject(AppState);
  public readonly translateService = inject(TranslocoService);

  changeLanguage(langKey: string): void {
    this.translateService.setActiveLang(langKey);
    localStorage.setItem(LANGUAGE_KEY, langKey);
  }
}
